import langs from '@/utils/langs'
 
export default  {
  'en.langs':langs.getLangs(require.context('./', true, /^\.\/modules\/([\s\S])+\.js$/)),
}


// WEBPACK FOOTER //
// ./src/i18n/locales/en-us/en.langs.js